function Tag({ text }: { text: string }) {
  return (
    <div className="bg-primary-2 rounded-lg mr-2 mb-2 px-2 py-0.5">
      <p className="font-semibold text-sm pb-0.5 whitespace-nowrap">{text}</p>
    </div>
  );
}

export default Tag;